import { DishFirstSegmentFilter, FoodTypeCoalesced, PriceLevel, Protein } from 'src/gqlReactTypings.generated.d';
import {
  Compostable,
  DairyFree,
  DietaryHalal,
  DietaryKosher,
  DietaryOrganic,
  DietaryPaleo,
  DietaryVegan,
  DietaryVegetarian,
  DietaryWhole30,
  DishTypeDessert,
  DishTypeMain,
  DishTypeSide,
  GlutenFree,
  ProteinBeef,
  ProteinChicken,
  ProteinFish,
  ProteinLamb,
  ProteinPork,
  ProteinSeafood,
} from 'src/shared/design-system/Icon';
import { DietaryTags, SpiceLevelOptions } from 'web-common/src/shared/Enums';
import { DisplayInfo } from './types';

export const SECTION_TEXT = {
  DISH_TYPE: {
    HEADER: 'Dish type',
  },
  DISH_RATING: {
    HEADER: 'Dish rating',
    RATING: {
      1: '60%+',
      2: '70%+',
      3: '80%+',
      4: '90%+',
    },
  },
  ECO: {
    HEADER: 'Eco Friendly packaging',
  },
  PRICE: {
    HEADER: 'Price range',
  },
  PROTEIN: {
    HEADER: 'Protein',
  },
  SPICE: {
    HEADER: 'Spice level',
  },
};

export const DISH_TYPE_TO_DISPLAY_INFO: Record<FoodTypeCoalesced, DisplayInfo> = {
  [FoodTypeCoalesced.Main]: { title: 'Mains', Icon: DishTypeMain },
  [FoodTypeCoalesced.Side]: { title: 'Sides', Icon: DishTypeSide },
  [FoodTypeCoalesced.Dessert]: { title: 'Desserts', Icon: DishTypeDessert },
};

export type LegacyProtein = Exclude<Protein, Protein.Shellfish | Protein.Egg | Protein.Tofu | Protein.Plant>;

export const PROTEIN_TO_DISPLAY_INFO: Record<LegacyProtein, DisplayInfo> = {
  [Protein.Chicken]: { title: 'Chicken', Icon: ProteinChicken },
  [Protein.Beef]: { title: 'Beef', Icon: ProteinBeef },
  [Protein.Pork]: { title: 'Pork', Icon: ProteinPork },
  [Protein.Lamb]: { title: 'Lamb', Icon: ProteinLamb },
  [Protein.Fish]: { title: 'Fish', Icon: ProteinFish },
  [Protein.Seafood]: { title: 'Seafood', Icon: ProteinSeafood },
};

export const PROTEINS = [Protein.Chicken, Protein.Beef, Protein.Pork, Protein.Lamb, Protein.Fish, Protein.Seafood];

export const COLLECTION_SEGMENT_DISPLAY_INFO = {
  [DishFirstSegmentFilter.RecommendedShefs]: { title: 'Popular Shefs' },
  [DishFirstSegmentFilter.NewShefs]: { title: 'New Shefs' },
  [DishFirstSegmentFilter.ShefsYouFollow]: { title: 'Shefs you follow' },
  [DishFirstSegmentFilter.Favorites]: { title: 'Favorites' },
  [DishFirstSegmentFilter.OrderAgain]: { title: 'Order again' },
  [DishFirstSegmentFilter.Promos]: { title: 'Delicious Deals' },
};

export const DIETARY_TO_DISPLAY_INFO: Record<DietaryTags, DisplayInfo> = {
  [DietaryTags.VEGETARIAN]: { title: 'Vegetarian', Icon: DietaryVegetarian },
  [DietaryTags.ORGANIC]: { title: 'Organic', Icon: DietaryOrganic },
  [DietaryTags.GLUTEN_FREE]: { title: 'Gluten free', Icon: GlutenFree },
  [DietaryTags.VEGAN]: { title: 'Vegan', Icon: DietaryVegan },
  [DietaryTags.HALAL]: { title: 'Halal', Icon: DietaryHalal },
  [DietaryTags.PALEO]: { title: 'Paleo', Icon: DietaryPaleo },
  [DietaryTags.LOW_FODMAP]: { title: 'Low FODmap', Icon: GlutenFree },
  [DietaryTags.DAIRY_FREE]: { title: 'Dairy free', Icon: DairyFree },
  [DietaryTags.COMPOSTABLE]: { title: 'Compostable', Icon: Compostable },
  [DietaryTags.WHOLE30]: { title: 'Whole 30', Icon: DietaryWhole30 },
  [DietaryTags.KOSHER]: { title: 'Kosher', Icon: DietaryKosher },
};

export const DIETARY = [
  DietaryTags.VEGETARIAN,
  DietaryTags.ORGANIC,
  DietaryTags.GLUTEN_FREE,
  DietaryTags.VEGAN,
  DietaryTags.HALAL,
  DietaryTags.PALEO,
];

export const PRICE_LEVELS = [
  PriceLevel.OneDollarSign,
  PriceLevel.TwoDollarSign,
  PriceLevel.ThreeDollarSign,
  PriceLevel.FourDollarSign,
];

export const PriceLevelToString: Record<PriceLevel, string> = {
  [PriceLevel.OneDollarSign]: '$',
  [PriceLevel.TwoDollarSign]: '$$',
  [PriceLevel.ThreeDollarSign]: '$$$',
  [PriceLevel.FourDollarSign]: '$$$$',
};

export const SPICE_LEVELS = [
  SpiceLevelOptions.NOT_SPICY,
  SpiceLevelOptions.MILD,
  SpiceLevelOptions.MEDIUM,
  SpiceLevelOptions.HOT,
];
